// extracted by css-extract-rspack-plugin
export default {"root":"Ams6gx"};